var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6699_44751)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6699_44751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8299 8.17935C15.8299 7.65268 15.7833 7.15268 15.7033 6.66602H8.16992V9.67268H12.4833C12.2899 10.6594 11.7233 11.4927 10.8833 12.0593V14.0593H13.4566C14.9633 12.666 15.8299 10.6127 15.8299 8.17935Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16979 15.9987C10.3298 15.9987 12.1365 15.2787 13.4565 14.0587L10.8831 12.0587C10.1631 12.5387 9.24979 12.8321 8.16979 12.8321C6.08312 12.8321 4.31645 11.4254 3.68312 9.52539H1.02979V11.5854C2.34312 14.1987 5.04312 15.9987 8.16979 15.9987Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68326 9.52544C3.51659 9.04544 3.42992 8.53211 3.42992 7.99877C3.42992 7.46544 3.52326 6.95211 3.68326 6.47211V4.41211H1.02992C0.483255 5.49211 0.169922 6.70544 0.169922 7.99877C0.169922 9.29211 0.483255 10.5054 1.02992 11.5854L3.68326 9.52544Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16979 3.16667C9.34979 3.16667 10.4031 3.57334 11.2365 4.36667L13.5165 2.08667C12.1365 0.793334 10.3298 0 8.16979 0C5.04312 0 2.34312 1.8 1.02979 4.41334L3.68312 6.47334C4.31645 4.57334 6.08312 3.16667 8.16979 3.16667Z",
    fill: "#EA4335"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6699_44751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6699_44751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.fd365fc726d3f93182e0d46bde692df1.svg";
export { ForwardRef as ReactComponent };